/** @jsxImportSource @emotion/react */
import { MedicalImage } from "../../../../assets/img/img";
import useBasePadding from "../../../../hooks/useBasePadding";
import useResponsive from "../../../../hooks/useResponsive";


export default function Section5() {
  const { GOLBAL_PADDING } = useBasePadding();
  const { isPc } = useResponsive();
  return (
    <div css={wrapper(GOLBAL_PADDING, !isPc)}>
      <img css={!isPc ? { width: "600px", height: "215px" } : ""} src={MedicalImage.Compatibility.FullImage} alt="FullImage" />
    </div>
  );
}

const wrapper = (padding: string, isMobile: boolean) => ({
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  paddingLeft: padding,
  paddingRight: padding,
  background: "black",
  // marginTop: isMobile ? "100px" : "50px",
});


